import { z } from 'zod';
import buildHttpError from '../shared/httpError';

const fetchAndValidate = async <S extends z.ZodType>(
  responsePromise: Promise<Response>,
  schema: S
): Promise<z.infer<S>> => {
  const res = await responsePromise;

  if (!res.ok) {
    throw await buildHttpError(res);
  }

  const jsonData: unknown = await res.json();
  return schema.parse(jsonData);
};

export default fetchAndValidate;
